/**
 * Mobile search form (solaroutlet-v2) — instant close, no morph
 * @class SearchForm
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer = this.closest('#Search-Drawer');
      this.form = this.querySelector('form');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.input = this.querySelector('.search-field');
      this.defaultTab = this.querySelector('.side-panel-content--initial');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');
      this.isMobileInlineSearch = !!this.closest('.header-mobile-search');
      this.mobileSearchHost = this.closest('.header-mobile-search');
      this.backButton = this.querySelector('.thb-search-back');
      this.isAnimating = false;
      this.mobileMorphRect = null;
      this.scrollLockY = null;
      this.closeFallbackTimer = null;
      this.closeTransitionHandler = null;
      this.onTouchMove = this.handleTouchMove.bind(this);
      this.onVisualViewportChange = this.updateMobileSearchViewport.bind(this);
      this.viewportListening = false;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', (event) => {
        if (this.isMobileInlineSearch && this.isMobileSearch()) {
          this.open();
        }
        this.onChange(event);
      });

      this.input.addEventListener('blur', () => {
        if (!this.isMobileInlineSearch || this.is_drawer) {
          return;
        }
        // Mobile Vollbild-Suche: nicht per Blur schließen (Scrollen/Tippen in Ergebnissen
        // würde sonst die Suche in den halb-offenen Morph-Zustand zurücksetzen).
        if (this.isMobileSearch()) {
          return;
        }
        window.setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.close();
          }
        }, 150);
      });

      this.button.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          document.body.classList.add('open-cc');
          if (this.is_drawer) {
            this.drawer.classList.add('active');
          }
          return false;
        });
      });

      this.cc?.addEventListener('click', this.close.bind(this));

      this.backButton?.addEventListener('click', (event) => {
        event.preventDefault();
        this.input.blur();
        this.close();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        if (!this.is_drawer) {
          if (this.isMobileInlineSearch && this.isMobileSearch() && document.activeElement === this.input) {
            this.predictiveSearchResults.setAttribute('inert', '');
            return;
          }
          this.close();
        }
        return;
      }
      if (!this.is_drawer) {
        this.open();
      }
      this.predictiveSearchResults.classList.add('active');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.predictiveSearchResults.innerHTML = '';
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {

      this.predictiveSearchResults.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      const submitBtn = this.predictiveSearchResults.querySelector('#search-results-submit');
      if (!submitBtn) {
        return;
      }

      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        submitBtn.classList.add('button', 'accent', 'full', 'search-results-submit--mobile');
        submitBtn.type = 'button';
      } else if (!this.is_drawer) {
        submitBtn.classList.remove('button');
      }

      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.submitSearch();
      });
    }
    submitSearch() {
      const query = this.getQuery();
      if (!query.length) {
        return;
      }

      const action = this.form.getAttribute('action') || '/search';
      const url = new URL(action, window.location.origin);
      url.searchParams.set('q', query);
      window.location.assign(url.toString());
    }

    close() {
      if (
        this.isMobileInlineSearch &&
        this.isMobileSearch() &&
        document.body.classList.contains('open-search') &&
        !this.isAnimating
      ) {
        this.closeMobileFullscreen();
        return;
      }
      this.finishClose();
    }
    open() {
      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        this.openMobileFullscreen();
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
    openMobileFullscreen() {
      this.cancelPendingClose();
      this.updateMobileSearchViewport();
      this.clearMorphVars();

      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }

      document.body.classList.add('open-search', 'open-search--expanded');
      this.predictiveSearchResults.removeAttribute('inert');
      this.lockBodyScroll();
      this.enableMobileScrollGuard();
      this.enableVisualViewportListener();
    }
    closeMobileFullscreen() {
      this.finishClose();
    }
    cancelPendingClose() {
      if (this.closeTransitionHandler) {
        this.removeEventListener('transitionend', this.closeTransitionHandler);
        this.closeTransitionHandler = null;
      }
      if (this.closeFallbackTimer) {
        clearTimeout(this.closeFallbackTimer);
        this.closeFallbackTimer = null;
      }
      this.isAnimating = false;
    }
    applyMorphVars(rect) {
      const root = document.documentElement;
      root.style.setProperty('--search-morph-top', rect.top + 'px');
      root.style.setProperty('--search-morph-left', rect.left + 'px');
      root.style.setProperty('--search-morph-width', rect.width + 'px');
      root.style.setProperty('--search-morph-height', rect.height + 'px');
      root.style.setProperty('--search-morph-radius', rect.radius || '6px');
    }
    clearMorphVars() {
      const root = document.documentElement;
      root.style.removeProperty('--search-morph-top');
      root.style.removeProperty('--search-morph-left');
      root.style.removeProperty('--search-morph-width');
      root.style.removeProperty('--search-morph-height');
      root.style.removeProperty('--search-morph-radius');
    }
    finishClose() {
      this.cancelPendingClose();
      this.mobileMorphRect = null;
      this.disableMobileScrollGuard();
      this.disableVisualViewportListener();
      this.unlockBodyScroll();
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search', 'open-search--expanded', 'open-search--keyboard-open');
      document.documentElement.style.removeProperty('--mobile-search-top');
      document.documentElement.style.removeProperty('--mobile-search-height');
      this.clearMorphVars();
      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }
    }
    lockBodyScroll() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch() || this.scrollLockY != null) {
        return;
      }
      this.scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      // Kein position:fixed auf Mobile — das blockiert Scrollen in der Ergebnisliste (iOS).
    }
    unlockBodyScroll() {
      if (this.scrollLockY == null) {
        return;
      }
      const scrollY = this.scrollLockY;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
      this.scrollLockY = null;
    }
    enableMobileScrollGuard() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }
      document.addEventListener('touchmove', this.onTouchMove, { passive: false });
    }
    disableMobileScrollGuard() {
      document.removeEventListener('touchmove', this.onTouchMove, { passive: false });
    }
    handleTouchMove(event) {
      if (!document.body.classList.contains('open-search--expanded')) {
        return;
      }

      const scrollArea = this.querySelector('.thb-predictive-search .side-panel-content--inner');
      if (!scrollArea) {
        return;
      }

      const path = event.composedPath?.() || [];
      const touchNode = path[0] || event.target;

      if (
        scrollArea === touchNode ||
        scrollArea.contains(touchNode) ||
        path.includes(scrollArea)
      ) {
        return;
      }

      const scrollHost = scrollArea.closest('scroll-shadow');
      if (scrollHost && (scrollHost === touchNode || scrollHost.contains(touchNode) || path.includes(scrollHost))) {
        return;
      }

      event.preventDefault();
    }
    isMobileSearch() {
      return window.matchMedia('(max-width: 1067px)').matches;
    }
    updateMobileSearchOffset() {
      this.updateMobileSearchViewport();
    }
    updateMobileSearchViewport() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }

      const announcement = document.querySelector('.announcement-bar-section');
      const announcementBottom = announcement
        ? Math.max(0, Math.round(announcement.getBoundingClientRect().bottom))
        : 0;

      document.documentElement.style.setProperty('--mobile-search-top', announcementBottom + 'px');

      if (!document.body.classList.contains('open-search--expanded')) {
        document.documentElement.style.removeProperty('--mobile-search-height');
        return;
      }

      this.clearMorphVars();
      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }

      // Tastatur zu: volle Höhe. Tastatur offen: sichtbarer Bereich (visualViewport).
      const vv = window.visualViewport;
      const layoutHeight = window.innerHeight;
      const visibleBottom = vv
        ? Math.round(vv.offsetTop + vv.height)
        : layoutHeight;
      const keyboardOpen = layoutHeight - visibleBottom > 80;
      const searchHeight = Math.max(0, visibleBottom - announcementBottom);

      if (keyboardOpen) {
        document.documentElement.style.setProperty('--mobile-search-height', searchHeight + 'px');
        document.body.classList.add('open-search--keyboard-open');
      } else {
        document.documentElement.style.removeProperty('--mobile-search-height');
        document.body.classList.remove('open-search--keyboard-open');
      }
    }
    enableVisualViewportListener() {
      if (this.viewportListening || !this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }
      this.viewportListening = true;
      this.updateMobileSearchViewport();
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.onVisualViewportChange);
        window.visualViewport.addEventListener('scroll', this.onVisualViewportChange);
      }
      window.addEventListener('resize', this.onVisualViewportChange);
    }
    disableVisualViewportListener() {
      if (!this.viewportListening) {
        return;
      }
      this.viewportListening = false;
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.onVisualViewportChange);
        window.visualViewport.removeEventListener('scroll', this.onVisualViewportChange);
      }
      window.removeEventListener('resize', this.onVisualViewportChange);
    }
  }
  customElements.define('search-form', SearchForm);
}